export class VtexCoupom {
  name: string;

  idCalculatorConfiguration: string;

  utmSource: string;

  description: string;

  isActive: boolean;

  status: string;

  beginDate: Date;

  endDate: Date;

  rules: string;

  exists?: boolean;

  constructor(props: VtexCoupom) {
    this.name = props.name;
    this.idCalculatorConfiguration = props.idCalculatorConfiguration;
    this.utmSource = props.utmSource;
    this.description = props.description;
    this.isActive = props.isActive;
    this.status = props.status;
    this.beginDate = new Date(props.beginDate.toString());
    this.endDate = new Date(props.endDate.toString());
    this.rules = props.rules;
    this.exists = props.exists;
  }
}
